import { HelpCenter } from "@mui/icons-material";

import VaultItem, {
  splitAndDivideStrings,
  splitAndMultiplyStrings,
} from "../vaultItem/VaultItem";
import Tooltip from "@mui/material/Tooltip";

export default function ClaimRewardsVaultItem(props) {
  function inputChange(evt, onClickData = false) {
    //const value = evt.target.value;

    let name, val;
    if (onClickData) {
      name = onClickData.name;
      val = onClickData.value;
    } else {
      name = evt.target.name;
      val = evt.target.value;
    }

    // console.log("inputChange->setInputs");
    props.setInputs((prevInputs) => {
      // рассчетный массив с данными для отсылки
      let calcInputs_ = {
        ...prevInputs,
        // [evt.target.name]: evt.target.value,
        [name]: val,
      };

      calcInputs_ = {
        ...calcInputs_,

        ...(!calcInputs_.claimTokensUsd &&
          calcInputs_.claim &&
          calcInputs_.claimUsd && {
            claimTokensUsd: splitAndDivideStrings(
              calcInputs_.claimUsd,
              calcInputs_.claim
            ),
          }),

        ...(!calcInputs_.claimUsd &&
          calcInputs_.claim &&
          calcInputs_.claimTokensUsd && {
            claimUsd: splitAndMultiplyStrings(
              calcInputs_.claim,
              calcInputs_.claimTokensUsd
            ),
          }),
      };

      props.setCalcInputs(calcInputs_);

      // массив с данными для вывода (не совпадает с расчетным чтобы скрывались поля)
      return {
        ...prevInputs,
        // [evt.target.name]: evt.target.value,
        [name]: val,
      };
    });
  }

  return (
    <div>
      {/* <HiddenBlock title="Claim Rewards"> */}
      <VaultItem
        title="Claim"
        showTitle={false}
        token="rewardToken"
        data={[
          { name: "claim", placeholder: 28.518 },
          { name: "claimUsd", placeholder: 2.1298 },
          { name: "claimTokensUsd", placeholder: 13.3899 },
        ]}
        inputs={props.inputs}
        inputChange={inputChange}
      />

      <label className="totalClaimed">
        Total Claimed {props.inputs.rewardToken}: 112.365 ($112.365){" "}
        <Tooltip title="Sum of all previous claims and the above claim.">
          <HelpCenter className="help helpIcon" />
        </Tooltip>
      </label>
      {/* </HiddenBlock> */}
    </div>
  );
}
